import { render } from "./UniversalTable.vue?vue&type=template&id=0caeb1a3&scoped=true"
import script from "./UniversalTable.vue?vue&type=script&lang=js"
export * from "./UniversalTable.vue?vue&type=script&lang=js"

import "./UniversalTable.vue?vue&type=style&index=0&id=0caeb1a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0caeb1a3"]])

export default __exports__